type actions = {
    type: string;
    payload: any
}

export const userReducer = (state = null, action: actions) => {
    switch (action.type) {
        case 'CHANGE_USER':
            return action.payload
    
        default:
            return state;
    }
}